import { RequestPerformer } from '@/api/api-requests-factory';
import { AuthApiResources } from '@/api/auth';
import { PlayersReportApiResources } from '@/api/players-report';
import { StatisticsApiResources } from '@/api/statistics';
import { TopListApiResources } from '@/api/top-list';
import { useEnvStore } from '@/store/env.store';
import { storeToRefs } from 'pinia';
import { PayoutOrderApiResources } from '@/api/payout-order';
import { TagExternalApiResources } from '@/api/tag-external';
import { PaymentsApiResources } from '@/api/payments';
import { SegmentExternalApiResources } from '@/api/segment-external';
import { AdminApiResources } from '@/api/admin';
import { DictionaryApiResources } from '@/api/dictionary';
import { DocumentListApiResources } from '@/api/documents';

export interface ApiResources {
  auth: AuthApiResources;
  statistics: StatisticsApiResources;
  topList: TopListApiResources;
  playersReport: PlayersReportApiResources;
  payoutOrders: PayoutOrderApiResources;
  tagExternal: TagExternalApiResources;
  payment: PaymentsApiResources;
  segmentExternat: SegmentExternalApiResources;
  admin: AdminApiResources;
  dictionary: DictionaryApiResources;
  documents: DocumentListApiResources;
}

export class ApiResourcesFactory {
  public getInstance(basePerformer: RequestPerformer): ApiResources {
    const { BACKOFFICE_API_URL, MULTIBRAND_API_HOST, MULTIBRAND_API_URL } = storeToRefs(useEnvStore());

    return {
      auth: new AuthApiResources(basePerformer, BACKOFFICE_API_URL),
      statistics: new StatisticsApiResources(basePerformer, MULTIBRAND_API_HOST),
      topList: new TopListApiResources(basePerformer, MULTIBRAND_API_HOST),
      playersReport: new PlayersReportApiResources(basePerformer, MULTIBRAND_API_HOST),
      payoutOrders: new PayoutOrderApiResources(basePerformer, MULTIBRAND_API_HOST),
      tagExternal: new TagExternalApiResources(basePerformer, MULTIBRAND_API_HOST),
      payment: new PaymentsApiResources(basePerformer, MULTIBRAND_API_HOST),
      segmentExternat: new SegmentExternalApiResources(basePerformer, MULTIBRAND_API_HOST),
      admin: new AdminApiResources(basePerformer, MULTIBRAND_API_HOST),
      dictionary: new DictionaryApiResources(basePerformer, MULTIBRAND_API_HOST, MULTIBRAND_API_URL),
      documents: new DocumentListApiResources(basePerformer, MULTIBRAND_API_HOST),
    };
  }
}
